"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MOTHER: 'mother',
    FATHER: 'father',
    AUNT_UNCLE: 'aunt/uncle',
    SIBLING: 'sibling',
    GUARDIAN: 'guardian/caregiver',
    COUNSELLOR: 'counsellor',
    OTHER: 'other',
};
//# sourceMappingURL=keyContactRelationship.js.map